import React from "react";
import ct from "class-types.macro";
import { BrandDetail } from "~/common/Store/models/Brand";
import TopProductsCarousel from "~/common/TopProductsCarousel/TopProductsCarousel";
import BrandNonFeaturedCategories from "./BrandNonFeaturedCategories";
import ExpandedBrandHeader from "./ExpandedBrandHeader";
import ExpandedBrandSections from "./ExpandedBrandSections";

import(/* webpackChunkName: "vendor" */ "~/less/vendor-alternate.less");

const ExpandedBrandPage = (props: BrandDetail) => {
  const {
    sections,
    nonFeaturedCategories,
    headline,
    visibleText,
    hiddenText,
    topProducts,
    expandedPageAttributes,
  } = props;
  return (
    <div data-component="storefront-expanded-brand">
      <ExpandedBrandHeader {...props} />
      <div className="container">
        <div id="page" className="clears vendor--alternate">
          <div id="main" role="main">
            <div className="grid-layout grid-layout--tuck">
              <div className="grid-container grid-container--compact grid-module-large">
                <div className="grid-module cols-grid grid-module--wrap grid-module--collapse">
                  {sections && (
                    <ExpandedBrandSections
                      sections={sections}
                      hideChildItemLinks={expandedPageAttributes.hideItemLinks}
                    />
                  )}
                  {!!topProducts?.length && (
                    <div
                      className={ct(
                        "mx-0",
                        "mb-0",
                        "overflow-hidden",
                        "md:mx-3",
                        "md:mb-3",
                      )}
                    >
                      <>
                        <TopProductsCarousel
                          topProducts={topProducts}
                          productListingView="topProductsCarousel"
                          itemWidth={ct("w-1/2", "xsl:w-48")}
                          pageType="Vendor"
                        />
                      </>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!!nonFeaturedCategories?.length && (
              <>
                <h2 className="vendor__title px-5 xs:p-0">
                  Shop All Categories
                </h2>
                <BrandNonFeaturedCategories
                  nonFeaturedCategories={nonFeaturedCategories}
                  categoriesPerPage={30}
                />
              </>
            )}
            <div className="flex sm:p-0 px-4 flex-col overflow-hidden grid-module--seo">
              <div className="sm:w-2/3">
                {headline?.length > 0 && <h3>{headline}</h3>}
                <p className="mb-0 text-sm leading-normal">
                  {visibleText?.length > 0 && (
                    <>
                      <span
                        className="mb-4 block"
                        dangerouslySetInnerHTML={{ __html: visibleText }}
                      />
                    </>
                  )}
                  {hiddenText?.length > 0 && (
                    <span
                      className="mb-4 block"
                      dangerouslySetInnerHTML={{ __html: hiddenText }}
                    />
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandedBrandPage;
